import React, { useEffect, useState } from "react";
import { useAuthState } from "../provider/AuthProvider";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Row, Col, Card, Space, Button, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import * as Request from "../commons/request";
import * as Common from "../commons/common";
import * as TypeDTO from "../commons/typeDTO";
import * as String from "../commons/string";

import ModalResetPassword from "../components/ModalResetPassword";

function MyPage() {
    const userDetails = useAuthState();
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState<TypeDTO.UserDto>();
    const [openResetPasswordPopup, setOpenResetPasswordPopup] = useState(false);
    const { confirm } = Modal;

    useEffect(() => {
        requestMemberInfo();
    }, []);

    const requestAxiosMemberInfo = async () => {
        if (userDetails === null) return null;
        if (userDetails?.token === null) return null;

        const response = await utilAxiosWithAuth().get(Request.MEMBER_INFO_URL);
        return response.data;
    };

    const { loading: loadingMembereInfo, error: errorMemberInfo, data: resultMemberInfo, execute: requestMemberInfo } = useAsyncAxios(requestAxiosMemberInfo);

    useEffect(() => {
        if (!resultMemberInfo) return;

        console.log("resultMemberInfo", resultMemberInfo);
        setUserInfo(resultMemberInfo.user);
    }, [resultMemberInfo]);

    useEffect(() => {
        if (!errorMemberInfo) return;

        console.log("errorMemberInfo", errorMemberInfo);
    }, [errorMemberInfo]);

    const showDeleteConfirm = () => {
        confirm({
            title: "정말 탈퇴 하시겠습니까?",
            icon: <ExclamationCircleFilled />,
            content: "계정 이용 내역이 있을 경우 재가입 시\n고객센터 본인인증 절차가 필요할 수 있습니다.",
            okText: String.confirm,
            okType: "danger",
            cancelText: String.cancel,
            onOk() {
                navigate(Common.PAGE_WITHDRAW_MEMBER);
            },
            onCancel() {},
        });
    };

    return (
        <>
            <div className="header-container">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="fadeIn text-center mb-3">
                            <h2 className="fs-title">계정정보</h2>
                        </div>
                    </div>
                </div>
            </div>
            <Row className="login pb-4" align="middle" justify="center">
                <div className="loginCard">
                    <Card bordered={false}>
                        <span>계정 타입</span>
                        <p className="login-input p-2 mt-2">{userInfo?.userType === "INDIVIDUAL" ? "개인 회원" : "법인 회원"}</p>
                        <span>{String.name}</span>
                        <p className="login-input p-2 mt-2">{userInfo?.name}</p>
                        {userInfo?.userType !== "INDIVIDUAL" ? (
                            <>
                                <span>회사명</span>
                                <p className="login-input p-2 mt-2">{userInfo?.companyName}</p>
                                <span>사업자 등록번호</span>
                                <p className="login-input p-2 mt-2">{userInfo?.companyRegistrationNo}</p>
                            </>
                        ) : null}
                        <span>{String.email}</span>
                        <p className="login-input p-2 mt-2">{userInfo?.email}</p>
                        <span>{String.phone}</span>
                        <p className="login-input p-2 mt-2">{userInfo?.phone}</p>
                        <span>{String.address}</span>
                        <p className="login-input p-2 mt-2">{userInfo?.address}</p>
                        {userInfo?.addressDetails && <p className="login-input p-2 mt-2">{userInfo?.addressDetails}</p>}
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button
                                        onClick={() =>
                                            navigate(Common.PAGE_UPDATE_MEMBER, {
                                                state: userInfo,
                                            })
                                        }
                                    >
                                        {String.edit}
                                    </Button>

                                    <Button onClick={() => setOpenResetPasswordPopup(true)}>비밀번호 재설정</Button>
                                    {openResetPasswordPopup && (
                                        <ModalResetPassword
                                            open={openResetPasswordPopup}
                                            onChangedOpen={(opened) => {
                                                setOpenResetPasswordPopup(opened);
                                            }}
                                        />
                                    )}
                                </Space>
                            </Col>
                            <Col span={12} className="text-end">
                                <Button danger onClick={showDeleteConfirm}>
                                    {String.withdraw}
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </Row>
        </>
    );
}

export default MyPage;
